

import { useReducer } from "react"
import { Box, Checkbox, InputLabel, FormControl, Radio, RadioGroup, FormControlLabel } from "@mui/material"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import lockedReducer from "../../../lib/reducer"
import { emitSnackbar } from "../../../lib/snackbar-emitter"
import api, { getEnterpriseId } from "../../../lib/api"
import { RoundedButton } from "../../../components/ui/roundButton"
import { loader } from "../../../lib/loader"
import { Input } from "../../../components/ui/input"
import { formatPhoneNumber } from "../../../services/scout"

const captcha = 'remover'
const DeletePhone = ({ account, handleClose, handleSuccess }) => {

  const [state, setState] = useReducer(lockedReducer, {
    captcha: '',
    backup: false,
    stage: 0,
    email: '',
    filetype: 'pdf' || 'csv'
  })

  const backupDelete = async () => {
    const enterpriseId = getEnterpriseId()
    loader.on()
    const payload = { email: state.email, id: account.id, type: state.filetype }
    const res = await api.post(`enterprises/${enterpriseId}/scout_accounts/${account.id}/exportallmessages/`, payload)
    if (res.status === 409) {
      emitSnackbar({ message: 'Já existe uma exportação em andamento para sua empresa, aguarde até que ela seja concluída, ou tente novamente em 1 hora.', severity: 'warning' })
      handleSuccess()
      handleClose()
    }
    else if (res.status === 200) {
      emitSnackbar({ message: 'A exportação de conversas foi iniciada e em breve estará disponível na caixa de e-mail selecionada. O número será excluído automaticamente.', severity: 'success' })
      handleSuccess()
      handleClose()
    }
    else
      emitSnackbar({ message: 'Não foi possível exportar as conversas desse número.', severity: 'error' })
    loader.off()
  }

  const deleteNumber = async (backup) => {
    if (state.backup) {
      await backupDelete()
      return
    }
    const enterpriseId = getEnterpriseId()
    loader.on()
    const res = await api.delete(
      `/enterprises/${enterpriseId}/scout_accounts/${account.id}/`,
      { timeout: 30000 }
    );
    if (res.status === 204) {
      emitSnackbar({ message: 'Número removido com sucesso.', severity: 'success' })
      handleClose()
      handleSuccess()
    } else {
      emitSnackbar({ message: 'Falha para remover o número.', severity: 'error' })
    }
    loader.off()
  }

  return (
    <DefaultModal
      title={
        'Excluir número'
      }
      handleClose={handleClose}
      maxWidth="xs"
      action={
        <Box width='100%' display='flex' gap='1rem' sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ width: '100%' }}>
            <RoundedButton onClick={handleClose} rounded='outlined' sx={{ width: '100%' }}>
              Cancelar
            </RoundedButton>
          </Box>
          <Box sx={{ width: '100%' }}>
            {(state.stage === 1 || !state.backup) &&
              <span sx={{ width: '100%' }}>
                <RoundedButton sx={{ width: '100%' }} disabled={captcha !== state.captcha} onClick={deleteNumber}>
                  Remover
                </RoundedButton>
              </span>
            }
            {state.stage === 0 && state.backup &&
              <span sx={{ width: '100%' }}>
                <RoundedButton sx={{ width: '100%' }} disabled={captcha !== state.captcha} onClick={() => { setState({ stage: 1 }) }}>
                  Continuar
                </RoundedButton>
              </span>
            }
          </Box>
        </Box>
      }
    >
      <Box display='flex' gap='1rem' flexDirection='column'>
        <Box className="bg-gray-100 rounded-xl p-4 text-center" sx={{ background: '#ebf4f6' }}>
          <Box className="font-bold text-sm text-gray-900">{account.name}</Box>
          <Box className="text-sm text-gray-400">{formatPhoneNumber(account.phone_number)}</Box>
        </Box>
        {state.stage === 0 ? <>
          <Box className="text-sm text-gray-700">
            Ao prosseguir, <strong>todas as conversas</strong> com esse número <strong>serão apagadas</strong> e não poderão mais ser recuperadas.
          </Box>
          <Box className="text-sm text-gray-700">
            Se deseja excluir este número, digite <strong>{captcha}</strong> no campo abaixo:
          </Box>
          <Input
            placeholder="Preencha e confirme"
            value={state.captcha}
            onChange={({ target }) => setState({ captcha: target.value })}
            className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-300 outline-none focus:border-gray-300 bg-white"
          />
          <div className="flex items-center space-x-2">
            <Checkbox
              id="backup"
              checked={state.backup}
              onChange={({ target }) => setState({ backup: !!target.checked })} />

            <InputLabel htmlFor="backup" className="text-xs text-muted-foreground cursor-pointer" style={{ fontSize: '.8em' }}>
              Baixar arquivo de backup com todas as conversas
            </InputLabel>

          </div>
        </> :
          <>
            <Box className="text-sm text-gray-700">
              Informe o e-mail que deverá receber o arquivo de backup e escolha o formato preferencial:
            </Box>
            <Input
              placeholder="colaborador@empresa.com.br"
              value={state.email}
              onChange={({ target }) => setState({ email: target.value })}
              className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-300 outline-none focus:border-gray-300 bg-white"
            />
            <FormControl>
              <RadioGroup
                value={state.filetype}
                onChange={(e) => setState({ filetype: e.target.value })}
              >
                <FormControlLabel
                  value="pdf"
                  control={<Radio size="small" />}
                  label={<>Arquivo <strong>.PDF</strong></>}
                />
                <FormControlLabel
                  value="csv"
                  control={<Radio size="small" />}
                  label={<>Arquivo <strong>.CSV</strong></>}
                />
              </RadioGroup>
            </FormControl>
          </>

        }


      </Box>
    </DefaultModal>
  )
}

export default DeletePhone